import React, { useEffect } from 'react';
import styled from 'styled-components';
import HelpText from 'screens/Book/components/HelpText';
import AppointmentTypeCard from './AppointmentTypeCard';
import Question from './Question';
import { AppointmentType, theme } from 'kb-shared';
import { BookingQuizCategory } from '../index';
import BackButton from '../../../components/Button/BackButton';
import { leftArrow2 } from '../../../../src/assets/icons';
import { AdditionalInfoPanel } from 'screens/Book/components/AdditionalInfoPanel';
interface QuizResultProps {
  appointmentTypes: Array<AppointmentType>;
  category?: BookingQuizCategory;
  isLoggedIn: boolean;
}

const QuizResult = ({ appointmentTypes, category, isLoggedIn }: QuizResultProps) => {
  const displayAppointmentType =
    appointmentTypes.find(apptType => !apptType.virtual) || appointmentTypes[0];

  useEffect(() => {
    if (window.analytics) {
      window.analytics.page('Appointment Recommendation', {
        // eslint-disable-next-line @typescript-eslint/camelcase
        appointment_category: category,
        // eslint-disable-next-line @typescript-eslint/camelcase
        appointment_type_name: displayAppointmentType.name,
        // eslint-disable-next-line @typescript-eslint/camelcase
        appointment_type_ids: appointmentTypes.map(apptType => apptType.id)
      });
    }
  }, [appointmentTypes, displayAppointmentType, category]);

  return (
    <>
      <Container>
        <Question category={category} text="We recommend..." />
        <AppointmentTypeCard
          appointmentType={displayAppointmentType}
          appointmentTypeIds={appointmentTypes.map(apptType => apptType.id)}
        />
        {category == 'wellness' && (
          <AdditionalInfoPanel>
            In order to provide you with the earliest availability for your appointment, the
            appointment times listed include all providers for this location. If you have a specific
            provider preference, please call us to book: 855-563-263
          </AdditionalInfoPanel>
        )}
        {!isLoggedIn && (
          <HelpText
            text="Looking for another service?"
            linkText="View all Services &amp; Pricing"
            linkUrl="https://kindbody.com/services-pricing/"
          />
        )}

        <BackButton
          style={{ alignSelf: 'start', marginTop: '85px' }}
          onClick={() => history.back()}
        >
          <ArrowIcon src={leftArrow2} />
          Back
        </BackButton>
      </Container>
    </>
  );
};

export default QuizResult;

const Container = styled.div`
  width: 100%;
`;

const ArrowIcon = styled.img`
  height: 12px;
  width: 40px;
  @media screen and (max-width: ${theme.breakpoints.largePhonePortrait}) {
    margin-right: -14px;
  }
`;
